import { Component } from '@angular/core';
import { Observable } from "rxjs";

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { JsaService } from '../../../../services/jsa/jsa.service';
import { JsaPaperService } from '../../../../services/jsaPaper/jsaPaper.service';
import { Router } from '@angular/router';
import { NearMissService } from '../../../../services/nearMiss/nearMiss.service';
import { GoodCatchService } from '../../../../services/goodCatch/goodCatch.service';
import { TrainingReqService } from '../../../../services/training/training-req.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonFunctionsService } from '../../../../services/common-functions.service';

@Component({
    selector: 'app-export-excel',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelect,
    MatOption,
    MatDatepickerModule,
    MatTableModule,
    MatIconModule
],
    templateUrl: './export-excel.component.html',
    styleUrl: './export-excel.component.css'
})
export class ExportExcelComponent {
  form: FormGroup;
  downloadSuccess = false;
  showHelpSection = false;
  downloadedFiles: string[] = [];

  constructor(private fb: FormBuilder, private router: Router,
    private jsaService: JsaService, private nearMissService: NearMissService, private jsaPaperService: JsaPaperService, private goodCatchService: GoodCatchService, private trainingReqService: TrainingReqService, private commonFuncs: CommonFunctionsService ) {}

    ngOnInit(): void {
      this.form = this.fb.group({
        safetyForm: [null, Validators.required],
        fromDate: [null],
        toDate: [null]
      })
    }

    onSubmit(): void {
      if (this.form.valid) {
        const safetyForm = this.form.value.safetyForm;
        this.downloadSuccess = false;
        this.showHelpSection = false;
      this.downloadedFiles = [];
  
        switch (safetyForm) {
          case 'jsa': {
            const { fromDate, toDate } = this.form.value;
            const startDate = fromDate ? this.commonFuncs.convertToUtc(fromDate) : undefined;
            const endDate = toDate ? this.commonFuncs.convertToUtcEod(toDate) : undefined;
            this.downloadExcel(this.jsaService.exportJsaExcel(startDate, endDate), 'JSA');
            break;
          }
          case 'jsaPaper':
            this.downloadExcel(this.jsaPaperService.exportJsaPaperExcel(), 'JsaPaper');
            break;
          case 'nearMiss':
            this.downloadExcel(this.nearMissService.exportNearMissExcel(), 'NearMiss');
            break;
          case 'goodCatch':
            this.downloadExcel(this.goodCatchService.exportGoodCatchExcel(), 'GoodCatch');
            break;
          case 'trainingReq':
            this.downloadExcel(this.trainingReqService.exportTrainingReqExcel(), 'TrainingRequest');
            break;
          case 'allForms':
            this.exportAllForms();
            break;
          default:
            console.error('Invalid selection');
            break;
        }
      }
    }
  
    private downloadExcel(downloadObservable: Observable<Blob>, filePrefix: string): void {
      downloadObservable.subscribe(
        (response: Blob) => {
          const url = window.URL.createObjectURL(response);
          const a = document.createElement('a');
          const today = new Date().toISOString().slice(0, 10);
          const fileName = `${today}_${filePrefix}.xlsx`;
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
  
          this.downloadSuccess = true;
          this.downloadedFiles.push(fileName);
        },
        (error) => console.error(`Error downloading ${filePrefix} Excel:`, error)
      );
    }
  
    private exportAllForms(): void {
      const downloads = [
        { observable: this.jsaService.exportJsaExcel(), prefix: 'JSA' },
        { observable: this.jsaPaperService.exportJsaPaperExcel(), prefix: 'JsaPaper' },
        { observable: this.nearMissService.exportNearMissExcel(), prefix: 'NearMiss' },
        { observable: this.goodCatchService.exportGoodCatchExcel(), prefix: 'GoodCatch' },
        { observable: this.trainingReqService.exportTrainingReqExcel(), prefix: 'TrainingRequest' }
      ];
  
      downloads.forEach(download => this.downloadExcel(download.observable, download.prefix));
    }

    toggleHelpSection(): void {
      this.showHelpSection = !this.showHelpSection;
    }
}
